var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex justify-content-center align-items-center pointer hover-item",on:{"click":function($event){$event.preventDefault();return _vm.audio_play()}}},[_c('img',{staticClass:"object-contain",attrs:{"src":require("@/assets/image/gept/voice_play.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }